<!--
@Author: Calvin Green <calvin>
@Date:   2021-10-06T10:42:05+02:00
@Email:  calvin@diversitude.com
@Last modified by:   calvin
@Last modified time: 2022-06-22T20:44:29+02:00
@Copyright: Diversitude 2022
-->

<template>
    <div>
        <div class="row">
            <div class="col-sm-12">
                <b-button class="me-2" variant="light" @click="$eventHub.$emit('navigateBack')">
                    <i class="fas fa-arrow-left"></i> Back
                </b-button>
            </div>
            <div class="col-sm-12" style="margin-top: 10px;">
                <b-button @click="toggleAddAudit()" class="me-2" variant="primary" >
                    Add Audit
                </b-button>
                <webix-ui :config="ui" v-model="clientAudits"></webix-ui>
                <div id="auditsPaging"></div>
            </div>
        </div>

        <b-modal size="lg" hide-footer id="auditModal" title="Add Audit">
            <!--<form-plugin uid="6128e50084e04"></form-plugin>-->
            <b-overlay :show="is_loading">
                <b-row>
                    <b-col cols="6">
                        <label  for="">Audit Type</label>
                        <b-form-select class="form-select" :options="allAudits" v-model="postdata.qms_audit_id"></b-form-select>
                    </b-col>
                </b-row>
                <div class="w-100 mt-2 mb-2" >
                    <b-button style="float: right;" variant="success" @click="saveClientAudit()">Add</b-button>
                    <b-button class="me-2" style="float: right;" @click="$bvModal.hide('auditModal')">Cancel</b-button>
                </div>
            </b-overlay>
        </b-modal>

    </div>
</template>
<script>
//import Swal from 'sweetalert2'
import { ccbAdminState, ccbAdminMethods } from '@/state/helpers'
export default {
    data:() => ({
        is_loading: false, 
        postdata: {
            client_id: -1, 
            qms_audit_id: -1
        },
        ui: {
            id: 'clientAuditsTable',
            view: 'datatable',
            css: "datatableUsers webix_header_border webix_data_border",
            autoheight: true,
            //hover: "datatableHover",
            minHeight:50,
            scrollY:false,
            scrollX:true,
            resizeColumn: true,
            select: false,
            pager:{
                template:"{common.prev()} {common.pages()} {common.next()}",
                container:"auditsPaging",
                size:15,
                group:5
            },
            columns:[
                { id: 'name', template:"<span class='viewAction' style='cursor: pointer;'>#name#</span>", header:["Audit Name", {content: "textFilter"}], tooltip:false, fillspace: 1},
                { id: 'code',  header:["Code", {content: "textFilter"}], fillspace: 1},
                { id: 'revise_every', header: 'Revision Period', fillspace: 1},
            ],
            on:{

            },
            onClick:{
                purchaseIcon: function() {
                    this.$scope.$parent.$swal.fire({
                      title: "Please contact support to activate this audit for your account!",
                      //text: "You won't be able to revert this!",
                      icon: "warning",
                      showCancelButton: false,
                      confirmButtonColor: "#34c38f",
                      cancelButtonColor: "#f46a6a",
                      confirmButtonText: "Ok"
                    });
                    
                },//eslint-disable-next-line
                viewAction: function(id, e, trg) {
                    var el = this.$scope.$parent;
                    el.getClientAudit(e.row).then(()=>{
                        el.setSelectedAuditID(e.row)
                    });
                },
            },            
        }
    }),
    computed:{
        ...ccbAdminState,
        allAudits() {
            let opts = [
                {value: -1, text: "Please select one"}
            ];
            this.client_data.available_audits.forEach(audit => {
                opts.push({
                    value: audit.id,
                    text: audit.name,
                });
            });
            return opts;
        },
        clientAudits() {
            return this.client_data.client_audits;
        }
    },
    methods: {
        ...ccbAdminMethods,
        toggleAddAudit() {
            this.$bvModal.show('auditModal');
        },
        saveClientAudit() {
            if (this.postdata.qms_audit_id == -1) {
                alert("check the form");
                return;
            }
            this.is_loading = true;
            this.postdata.client_id = this.client_data.client.id;
            this.addClientAudit(this.postdata)
            .then(()=>{
                this.loadClientData(this.client_data.client.id);
                this.$bvModal.hide('auditModal');
                this.is_loading = false;
            });
        }
    },
    mounted(){

    },
}
</script>

<style>

</style>
